import { APITypes } from '../primary-record-types';
import useMedicalProfiles from './api/useMedicalProfiles';
import { useLoadedUser } from './api/useUser';

export function useGetIsUserProfile() {
    const user = useLoadedUser({});

    return (profile: APITypes.medicalProfileService.ProfileListItem | null) => {
        if (!profile) return false;

        return profile.firstName === user?.user.firstName && profile.lastName === user?.user.lastName;
    };
}

export const useFindUserProfile = () => {
    const user = useLoadedUser({});

    return (profiles: APITypes.medicalProfileService.ProfileListItem[]) => {
        return profiles.find((_) => {
            return _.firstName === user?.user.firstName && _.lastName === user?.user.lastName;
        });
    };
};

export default function useUserHasOwnMedicalProfile(): boolean {
    const getIsUserProfile = useGetIsUserProfile();
    const { isLoadingProfiles, medicalProfiles } = useMedicalProfiles();

    if (isLoadingProfiles) return false;

    return !!medicalProfiles.find((_) => {
        return getIsUserProfile(_);
    });
}
